import { useEffect, useState } from "react";
import { useEntityLookup } from "../../core/hooks/useEntityLookup";
import { Tab } from "../../core/ui/Tab";
import { Table } from "../../core/ui/Table";
import { CustomCol, GenericCol } from "../../layout/TableCells";
import { entity, entity_rel, EntityData, getRelationshipTypeName } from "../../types";
import { api } from "../../api/api";


export function RelationshipsTabContent(props: {
	entity: entity,
}) {

	if (!props.entity.data.relationships) props.entity.data.relationships = [];

	const [relationships, setRelationships] = useState<entity_rel[] | undefined>();

	// fetch other relationships
	useEffect(() => {
		api.entity_relationships({
			entity: props.entity.id,
		}).then((results) => {
			setRelationships(results);

		}).catch(() => {

		});
	}, []);

	const entities = useEntityLookup(
		relationships!,
		(item) => {
			return (item.related === props.entity.id) ? item.entity : item.related;
		}
	);

	return (
		<Table
			cols={[
				CustomCol({
					title: () => "Name",
					value: (r, c) => {
						if (!entities || !entities.map) return;

						const e = entities.map[(props.entity.id !== r.related) ? r.related : r.entity];
						return e.title;
					}
				}),
				CustomCol({
					title: () => "Relationship", 
					value: (r, c) => {
						return getRelationshipTypeName(r.type);
					}
				}),
			]}
			items={relationships}
		/>
	);
}